import React from 'react';
import Button from '@mui/material/Button';
import { CustomMuiIcon } from 'assets/images/icons/customMuiIcons';
import { useWindowScrollY } from 'shared/hooks/useWindowScrollY';

export const GoToTopButton: React.FC = () => {
  const { isVisible, isFixed } = useWindowScrollY();

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Button
      sx={{
        width: '56px',
        minWidth: '56px',
        height: '56px',
        borderRadius: '50%',
        display: { md: 'flex', xs: 'none' },
        backgroundColor: 'myGrey.grey600',
        opacity: isVisible ? 0.5 : 0,
        position: isFixed ? 'fixed' : 'absolute',
        bottom: isFixed ? { lg: '40px', md: '22px' } : '25px',
        right: isFixed ? { lg: '40px', md: '22px' } : '0px',
        zIndex: 1000,
        transition: 'opacity 300ms ease-in-out',
        pointerEvents: isVisible ? 'auto' : 'none',
        '&:hover': {
          backgroundColor: 'myGrey.grey600',
          opacity: 0.8,
        },
      }}
      onClick={handleClick}
    >
      <CustomMuiIcon type="icon-arrow-up" sx={{ fill: 'none' }} />
    </Button>
  );
};
